import React from "react";
import "./Responsibilty.css";
export default function Responsibility() {
  return (
    <section className="responsibility-section">
      <h2>Global Responsibility: Sustainability and Food Security</h2>

      <div className="responsibility-banner">
        <h3>Global Responsibility:</h3>
        <ul>
          <li>Food Security Focus</li>
          <li>Ethical Sourcing</li>
          <li>Sustainable Practices</li>
        </ul>
      </div>
    </section>
  );
}
